<div
    class="my-56 flex w-full flex-col justify-center gap-4 place-self-center px-8 text-left lg:max-w-1/2 lg:text-center"
>
    <h1 class="lg:text-display-large text-headline-large">
        {{ confirmationBlock().translations_refs | getTranslation: "title" }}
    </h1>
    <h2 class="lg:text-headline-smal text-title-medium">
        {{ confirmationBlock().translations_refs | getTranslation: "subtitle" }}
    </h2>
    <p class="text-body-small">{{ confirmationBlock().translations_refs | getTranslation: "message" }}</p>

    @if (link()) {
        <a
            [href]="link()?.page_ref | pathFromItem: 'page'"
            [target]="'_self'"
            class="border-primary text-body-small hover:bg-primary-50 bg-primary w-fit cursor-pointer rounded-md border px-4 py-2 text-center text-white transition-colors lg:place-self-center"
        >
            {{ link()?.translations_refs | getTranslation: "title" }}
        </a>
    }
</div>
